import { IssueOnSingleView } from 'components/dataProviders/withIssue/IssueOnSingleView';
import { Issue } from 'setup/types/core';
import { FieldSkeleton, IssueForm } from 'shared/types/form';
import { ProcessType } from 'shared/domain/process/types/model';
import { ColumnValue } from 'components/table/types';
import { ColumnKey } from 'components/table/columnShapes/types';
import { ColumnShape } from 'react-base-table';
import { LabelledEntity } from 'shared/types/commonView';

export type IssueTableColumn = ColumnShape & LabelledEntity;

export interface TableState {
  items: Issue[];
  currentPageLoaded: number;
  sorted: boolean;
}

export const fixedColumnsIds = [ColumnKey.no, ColumnKey.process, 'stage'];

export type ExtractFieldData = (
  processes: ProcessType[],
  issueForm: IssueForm,
  duplicates: string[]
) => { pri: FieldSkeleton[]; ext: FieldSkeleton[] };

export type IssueData =
  | IssueOnSingleView['primaryData']
  | IssueOnSingleView['extendedData'];

export type AccessorCreator = (
  data: IssueData,
  field: FieldSkeleton
) => ColumnValue;
